import React from "react";
import { CircularProgress, Skeleton } from "@mui/material";
import {
  TopTextContainer,
  BottomTextContainer,
  BarcodeContentContainer,
} from "../styles";

const LoadingState: React.FC = () => (
  <>
    <TopTextContainer style={{ padding: 0 }}>
      <Skeleton variant="rectangular" sx={{ width: "100%", height: "45px" }} />
    </TopTextContainer>
    <BarcodeContentContainer>
      <CircularProgress sx={{ color: "#0e893c" }} />
    </BarcodeContentContainer>
    <BottomTextContainer style={{ padding: 0 }}>
      <Skeleton variant="rectangular" sx={{ width: "100%", height: "41px" }} />
    </BottomTextContainer>
  </>
);

export default LoadingState;
